



























import {Vue, Component, Prop} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import Validations from '../lib/Validations'
import {DialogState} from '../store'

import Container from './/proxy/Container.vue'
import FormTag from './proxy/Inputs/FormTag.vue'
import TextField from './proxy/Inputs/TextField.vue'
import Layout from './proxy/Layout.vue'
import Button from './Button.vue'
import ConfirmDialogCallback from '../views/ConfirmDialogCallback.vue'
import {DriverInvite} from '../lib/kepler/interfaces'

@Component({
  components: {
    Button,
    Layout,
    Container,
    TextField,
    FormTag,
  },
  name: 'addDriver',
})
export default class AddDriver extends Vue {
  @Action('closePopup') protected closePopup: any
  @Action('inviteDriver') protected inviteDriver: any
  @Action('openDialog') protected openDialog: any

  protected rules: any = Validations.rules
  protected valid: boolean = false
  protected inviteRequest: DriverInvite = {
    name: '',
    surname: '',
    email: '',
  }

  protected save() {
    if (this.valid) {
      this.inviteDriver(this.inviteRequest).then((r: any) => {
          this.openDialog(new DialogState(ConfirmDialogCallback, {
            code: '',
            title: this.$t('common.great'),
            subtitle: this.$t('profile.invite_driver'),
            confirmText: this.$t('profile.wallet.addCard.confirmation.button'),
            imageState: 'icons/invitedriver.svg',
            singleAction: true,
            confirmCallback: () => {
              this.closePopup()
            },
          }))
        },
      )
    }
  }
}
